import { ReactNode, useMemo, useState } from 'react';

import DrawerDomainRenewal from 'components/standard/DrawerDomainRenewal';
import DialogTransferOutDomain from 'components/standard//DialogTransferOutDomain';
import { actionsContext } from './actionsContext';

export interface ActionsProviderProps {
	canRenewDomain: boolean;
	domain: string;
	dregUniqId: string | undefined;
	children: ReactNode;
}

export const ActionsProvider = ({
	canRenewDomain,
	domain,
	dregUniqId,
	children,
}: ActionsProviderProps) => {
	const [isRenewDrawerOpen, setRenewDrawerOpen] = useState(false);
	const [isTransferDialogOpen, setTransferDialogOpen] = useState(false);

	const contextValue = useMemo(
		() => ({
			isRenewDrawerOpen,
			isTransferDialogOpen,
			toggleRenewDrawer: () => setRenewDrawerOpen((prev) => !prev),
			toggleTransferDialog: () => setTransferDialogOpen((prev) => !prev),
		}),
		[isRenewDrawerOpen, isTransferDialogOpen],
	);

	return (
		<actionsContext.Provider value={contextValue}>
			{children}

			{canRenewDomain && (
				<DrawerDomainRenewal
					domain={domain}
					open={isRenewDrawerOpen}
					onClose={() => setRenewDrawerOpen(false)}
				/>
			)}

			{dregUniqId && (
				<DialogTransferOutDomain
					domain={domain}
					open={isTransferDialogOpen}
					uniqId={dregUniqId}
					onClose={() => setTransferDialogOpen(false)}
				/>
			)}
		</actionsContext.Provider>
	);
};

export default ActionsProvider;
